import { createAction } from '@reduxjs/toolkit';

import { DRAWER_COLLAPSED } from './types';

export const changeCollapsed = createAction<boolean>(DRAWER_COLLAPSED);
